import LogProvider from '../classes/log-provider'
import { isBrowser } from '../utils/environment'
import { uniqueString } from '../utils/string'

const IS_BROWSER = isBrowser()

const GTM_EVENT_NAMES = /pageload/i
const GTM_NON_INTERACTION_EVENT_NAMES = /pageload/i

const _maxTags = uniqueString('GTMProvider_maxTags')
const _tags = uniqueString('GTMProvider_tags')

const parseTag = (tag) => (tag.serialize ? tag.serialize() : tag)

export default class GTMProvider extends LogProvider {
  static get is() {
    return 'GTMProvider'
  }

  constructor(config) {
    super(config)

    this[_tags] = []
    this[_maxTags] = config.maxTags
  }

  log(...tags) {
    if (!IS_BROWSER) return

    try {
      tags = tags.filter(GTMProvider.isTag).map(GTMProvider.serialize)
    } catch (error) {
      console.error(error)
    }

    for (const tag of tags) {
      GTMProvider.dataLayer.push(tag)
      this[_tags].push(tag)
    }

    const diff = this[_tags].length - this[_maxTags]

    if (diff > 0) {
      this[_tags].splice(0, diff)
    }
  }

  static isTag(tag) {
    const data = parseTag(tag)

    return GTMProvider.isGATag(data) || GTMProvider.isSetiTag(data)
  }

  static isGATag(tag) {
    const data = parseTag(tag)

    return !!(data && data.category && data.action)
  }

  static isSetiTag(tag) {
    const data = parseTag(tag)

    return !!(data && data.event === 'seti' && data.teamName && data.dimension && data.variantName)
  }

  static transformEventName(event = '') {
    const isEvent = GTM_EVENT_NAMES.test(event)
    const eventName = isEvent ? event : 'custom'

    return `gtm-${eventName}-event`
  }

  static serialize(tag) {
    const data = parseTag(tag)

    if (GTMProvider.isGATag(data)) {
      const eventName = GTMProvider.transformEventName(data.event)
      const tag = {
        event: eventName,
        'gtm-event-category': data.category,
        'gtm-event-action': data.action,
        'gtm-event-label': data.label,
      }

      if (GTM_NON_INTERACTION_EVENT_NAMES.test(data.event)) {
        tag.nonInteraction = 1
      }

      return tag
    } else if (GTMProvider.isSetiTag(data)) {
      const setiTag = {
        event: 'seti',
        seti_team_name: data.teamName,
      }

      setiTag[`dimension${data.dimension}`] = data.variantName

      return setiTag
    }
  }

  static get dataLayer() {
    let dataLayer = null

    if (IS_BROWSER) {
      if (!window.dataLayer) {
        dataLayer = window.dataLayer = []
      } else {
        dataLayer = window.dataLayer
      }
    }

    return dataLayer
  }
}
